import {
  usePermissions,
  useSelectedCompany,
} from "@flash-tecnologia/hros-web-utility";

export const useCanViewSetup = () => {
  const { selectedCompany } = useSelectedCompany();
  const { isAdmin, companies } = usePermissions();

  return (
    isAdmin ||
    companies
      .find((c) => c.id === selectedCompany.id)
      ?.permissions.includes("core_create_employee")
  );
};
